<template>
  <div class="home">
    <manycontent-navbar/>
    <manycontent-header/>

    <div class="bg-solid-gray">
      <section-how-it-works/>
      <section-steps/>
      <section-benefits/>
    </div>
    <div class="bg-solid-blue">
      <section-price/>
    </div>
    <div class="bg-solid-green">
      <section-warranty/>
    </div>
    <div class="bg-solid-gray">
      <section-faq/>
    </div>
    <manycontent-footer/>
  </div>
</template>

<script>
import ManycontentNavbar from '@/components/Navbar'
import ManycontentHeader from '@/components/Header'
const ManycontentFooter = () => import('@/components/Footer')
const SectionHowItWorks = () => import('@/components/SectionHowItWorks')
const SectionSteps = () => import('@/components/SectionSteps')
const SectionBenefits = () => import('@/components/SectionBenefits')
const SectionPrice = () => import('@/components/SectionPrice')
const SectionWarranty = () => import('@/components/SectionWarranty')
const SectionFaq = () => import('@/components/SectionFaq')

export default {
  components: {
    ManycontentNavbar,
    ManycontentHeader,
    ManycontentFooter,
    SectionHowItWorks,
    SectionSteps,
    SectionBenefits,
    SectionPrice,
    SectionWarranty,
    SectionFaq
  }
}
</script>
